// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file pcf_export_service.proto (package pipeex.pcf.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { StartOperationResponseSchema } from "./revit_service_pb";
import { file_revit_service } from "./revit_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pcf_export_service.proto.
 */
export const file_pcf_export_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_revit_service]);

/**
 * @generated from message pipeex.pcf.v1.PipingSystemDto
 */
export type PipingSystemDto = Message<"pipeex.pcf.v1.PipingSystemDto"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int64 revit_id = 2;
   */
  revitId: bigint;

  /**
   * @generated from field: map<string, string> props = 3;
   */
  props: { [key: string]: string };
};

/**
 * Describes the message pipeex.pcf.v1.PipingSystemDto.
 * Use `create(PipingSystemDtoSchema)` to create a new message.
 */
export const PipingSystemDtoSchema: GenMessage<PipingSystemDto> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 0);

/**
 * @generated from message pipeex.pcf.v1.PcfSettingsDto
 */
export type PcfSettingsDto = Message<"pipeex.pcf.v1.PcfSettingsDto"> & {
  /**
   * @generated from field: string advanced_settings = 1;
   */
  advancedSettings: string;

  /**
   * @generated from field: string all_tags = 2;
   */
  allTags: string;

  /**
   * @generated from field: string bom_parameters = 3;
   */
  bomParameters: string;

  /**
   * @generated from field: string iso_parameters = 4;
   */
  isoParameters: string;

  /**
   * @generated from field: string validation_map = 5;
   */
  validationMap: string;

  /**
   * @generated from field: pipeex.pcf.v1.SettingsType settings_type = 6;
   */
  settingsType: SettingsType;
};

/**
 * Describes the message pipeex.pcf.v1.PcfSettingsDto.
 * Use `create(PcfSettingsDtoSchema)` to create a new message.
 */
export const PcfSettingsDtoSchema: GenMessage<PcfSettingsDto> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 1);

/**
 * @generated from message pipeex.pcf.v1.CollectSystemsRequest
 */
export type CollectSystemsRequest = Message<"pipeex.pcf.v1.CollectSystemsRequest"> & {
  /**
   * @generated from field: bool by_system_type = 1;
   */
  bySystemType: boolean;

  /**
   * Export scope switch: when true the host also walks Revit links
   * loaded into the active document. Absent/false — the wire default —
   * keeps the historical active-document-only behaviour, so older UI
   * builds and direct gRPC clients are unaffected.
   *
   * @generated from field: bool include_linked_models = 2;
   */
  includeLinkedModels: boolean;
};

/**
 * Describes the message pipeex.pcf.v1.CollectSystemsRequest.
 * Use `create(CollectSystemsRequestSchema)` to create a new message.
 */
export const CollectSystemsRequestSchema: GenMessage<CollectSystemsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 2);

/**
 * @generated from message pipeex.pcf.v1.CollectSystemsResponse
 */
export type CollectSystemsResponse = Message<"pipeex.pcf.v1.CollectSystemsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.pcf.v1.PipingSystemDto systems = 3;
   */
  systems: PipingSystemDto[];
};

/**
 * Describes the message pipeex.pcf.v1.CollectSystemsResponse.
 * Use `create(CollectSystemsResponseSchema)` to create a new message.
 */
export const CollectSystemsResponseSchema: GenMessage<CollectSystemsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 3);

/**
 * @generated from message pipeex.pcf.v1.ExportSystemsRequest
 */
export type ExportSystemsRequest = Message<"pipeex.pcf.v1.ExportSystemsRequest"> & {
  /**
   * @generated from field: bool export_selected = 1;
   */
  exportSelected: boolean;

  /**
   * @generated from field: bool by_system_type = 2;
   */
  bySystemType: boolean;

  /**
   * @generated from field: repeated pipeex.pcf.v1.PipingSystemDto systems = 3;
   */
  systems: PipingSystemDto[];

  /**
   * @generated from field: string save_folder = 4;
   */
  saveFolder: string;

  /**
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto settings = 5;
   */
  settings?: PcfSettingsDto | undefined;
};

/**
 * Describes the message pipeex.pcf.v1.ExportSystemsRequest.
 * Use `create(ExportSystemsRequestSchema)` to create a new message.
 */
export const ExportSystemsRequestSchema: GenMessage<ExportSystemsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 4);

/**
 * @generated from message pipeex.pcf.v1.ExportSystemsResponse
 */
export type ExportSystemsResponse = Message<"pipeex.pcf.v1.ExportSystemsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * Count of piping systems actually written to PCF files. Useful for
   * pick-mode where the UI doesn't know upfront how many systems the
   * picked elements span. List-mode also fills it for symmetry.
   *
   * @generated from field: int32 systems_exported = 3;
   */
  systemsExported: number;
};

/**
 * Describes the message pipeex.pcf.v1.ExportSystemsResponse.
 * Use `create(ExportSystemsResponseSchema)` to create a new message.
 */
export const ExportSystemsResponseSchema: GenMessage<ExportSystemsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 5);

/**
 * @generated from message pipeex.pcf.v1.CollectSnapshotForExportRequest
 */
export type CollectSnapshotForExportRequest = Message<"pipeex.pcf.v1.CollectSnapshotForExportRequest"> & {
  /**
   * @generated from field: bool by_system_type = 1;
   */
  bySystemType: boolean;

  /**
   * System filter — when empty the plugin builds a snapshot covering
   * every piping system in the active document. Otherwise the snapshot
   * is built normally and the React orchestrator drives the system
   * filter through PcfConfig downstream.
   *
   * @generated from field: repeated pipeex.pcf.v1.PipingSystemDto systems = 2;
   */
  systems: PipingSystemDto[];

  /**
   * Active PCF settings/profile selected in the React UI. When omitted,
   * the plugin falls back to its bundled PcfConfig defaults for backward
   * compatibility with older clients.
   *
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto settings = 3;
   */
  settings?: PcfSettingsDto | undefined;
};

/**
 * Describes the message pipeex.pcf.v1.CollectSnapshotForExportRequest.
 * Use `create(CollectSnapshotForExportRequestSchema)` to create a new message.
 */
export const CollectSnapshotForExportRequestSchema: GenMessage<CollectSnapshotForExportRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 6);

/**
 * @generated from message pipeex.pcf.v1.CollectSnapshotForExportResponse
 */
export type CollectSnapshotForExportResponse = Message<"pipeex.pcf.v1.CollectSnapshotForExportResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * gzip-compressed UTF-8 JSON of RevitSnapshot (PipeeX.Models). The
   * React orchestrator forwards this verbatim to POST /api/pcf-runs.
   *
   * @generated from field: bytes snapshot_gzip_json = 3;
   */
  snapshotGzipJson: Uint8Array;

  /**
   * PCF settings resolved against the active document, in the same
   * shape as ExportSystemsRequest.settings.
   *
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto current_settings = 4;
   */
  currentSettings?: PcfSettingsDto | undefined;

  /**
   * True when the plugin reused snapshot.pivot for the unchanged saved model.
   * Selected systems are still sent separately to the server for filtering.
   *
   * @generated from field: bool snapshot_cache_hit = 5;
   */
  snapshotCacheHit: boolean;
};

/**
 * Describes the message pipeex.pcf.v1.CollectSnapshotForExportResponse.
 * Use `create(CollectSnapshotForExportResponseSchema)` to create a new message.
 */
export const CollectSnapshotForExportResponseSchema: GenMessage<CollectSnapshotForExportResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 7);

/**
 * @generated from message pipeex.pcf.v1.WritePcfFileEntry
 */
export type WritePcfFileEntry = Message<"pipeex.pcf.v1.WritePcfFileEntry"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;
};

/**
 * Describes the message pipeex.pcf.v1.WritePcfFileEntry.
 * Use `create(WritePcfFileEntrySchema)` to create a new message.
 */
export const WritePcfFileEntrySchema: GenMessage<WritePcfFileEntry> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 8);

/**
 * @generated from message pipeex.pcf.v1.WritePcfFilesToDiskRequest
 */
export type WritePcfFilesToDiskRequest = Message<"pipeex.pcf.v1.WritePcfFilesToDiskRequest"> & {
  /**
   * @generated from field: string save_folder = 1;
   */
  saveFolder: string;

  /**
   * @generated from field: repeated pipeex.pcf.v1.WritePcfFileEntry files = 2;
   */
  files: WritePcfFileEntry[];
};

/**
 * Describes the message pipeex.pcf.v1.WritePcfFilesToDiskRequest.
 * Use `create(WritePcfFilesToDiskRequestSchema)` to create a new message.
 */
export const WritePcfFilesToDiskRequestSchema: GenMessage<WritePcfFilesToDiskRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 9);

/**
 * @generated from message pipeex.pcf.v1.PcfFileWriteIssue
 */
export type PcfFileWriteIssue = Message<"pipeex.pcf.v1.PcfFileWriteIssue"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: string suggested_action = 3;
   */
  suggestedAction: string;

  /**
   * @generated from field: bool fatal = 4;
   */
  fatal: boolean;
};

/**
 * Describes the message pipeex.pcf.v1.PcfFileWriteIssue.
 * Use `create(PcfFileWriteIssueSchema)` to create a new message.
 */
export const PcfFileWriteIssueSchema: GenMessage<PcfFileWriteIssue> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 10);

/**
 * @generated from message pipeex.pcf.v1.WritePcfFilesToDiskResponse
 */
export type WritePcfFilesToDiskResponse = Message<"pipeex.pcf.v1.WritePcfFilesToDiskResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 files_written = 3;
   */
  filesWritten: number;

  /**
   * @generated from field: repeated string skipped_files = 4;
   */
  skippedFiles: string[];

  /**
   * @generated from field: repeated pipeex.pcf.v1.PcfFileWriteIssue issues = 5;
   */
  issues: PcfFileWriteIssue[];

  /**
   * Exact names whose bytes were durably observed at the output folder.
   * files_written always equals written_files.size().
   *
   * @generated from field: repeated string written_files = 6;
   */
  writtenFiles: string[];

  /**
   * Canonical folder resolved by the plugin after it was created/validated.
   *
   * @generated from field: string resolved_save_folder = 7;
   */
  resolvedSaveFolder: string;
};

/**
 * Describes the message pipeex.pcf.v1.WritePcfFilesToDiskResponse.
 * Use `create(WritePcfFilesToDiskResponseSchema)` to create a new message.
 */
export const WritePcfFilesToDiskResponseSchema: GenMessage<WritePcfFilesToDiskResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 11);

/**
 * @generated from message pipeex.pcf.v1.CollectPickedSnapshotForExportRequest
 */
export type CollectPickedSnapshotForExportRequest = Message<"pipeex.pcf.v1.CollectPickedSnapshotForExportRequest"> & {
  /**
   * @generated from field: bool by_system_type = 1;
   */
  bySystemType: boolean;

  /**
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto settings = 2;
   */
  settings?: PcfSettingsDto | undefined;
};

/**
 * Describes the message pipeex.pcf.v1.CollectPickedSnapshotForExportRequest.
 * Use `create(CollectPickedSnapshotForExportRequestSchema)` to create a new message.
 */
export const CollectPickedSnapshotForExportRequestSchema: GenMessage<CollectPickedSnapshotForExportRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 12);

/**
 * @generated from message pipeex.pcf.v1.CollectPickedSnapshotForExportResponse
 */
export type CollectPickedSnapshotForExportResponse = Message<"pipeex.pcf.v1.CollectPickedSnapshotForExportResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: bool cancelled = 3;
   */
  cancelled: boolean;

  /**
   * @generated from field: bytes snapshot_gzip_json = 4;
   */
  snapshotGzipJson: Uint8Array;

  /**
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto current_settings = 5;
   */
  currentSettings?: PcfSettingsDto | undefined;

  /**
   * @generated from field: int32 elements_picked = 8;
   */
  elementsPicked: number;
};

/**
 * Describes the message pipeex.pcf.v1.CollectPickedSnapshotForExportResponse.
 * Use `create(CollectPickedSnapshotForExportResponseSchema)` to create a new message.
 */
export const CollectPickedSnapshotForExportResponseSchema: GenMessage<CollectPickedSnapshotForExportResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 13);

/**
 * @generated from message pipeex.pcf.v1.ApplyPcfVisualCheckRequest
 */
export type ApplyPcfVisualCheckRequest = Message<"pipeex.pcf.v1.ApplyPcfVisualCheckRequest"> & {
  /**
   * @generated from field: pipeex.pcf.v1.LocalPcfGrouping grouping = 1;
   */
  grouping: LocalPcfGrouping;

  /**
   * @generated from field: string parameter_name = 2;
   */
  parameterName: string;

  /**
   * @generated from field: pipeex.pcf.v1.PcfVisualParameterSource parameter_source = 3;
   */
  parameterSource: PcfVisualParameterSource;
};

/**
 * Describes the message pipeex.pcf.v1.ApplyPcfVisualCheckRequest.
 * Use `create(ApplyPcfVisualCheckRequestSchema)` to create a new message.
 */
export const ApplyPcfVisualCheckRequestSchema: GenMessage<ApplyPcfVisualCheckRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 14);

/**
 * @generated from message pipeex.pcf.v1.ApplyPcfVisualCheckResponse
 */
export type ApplyPcfVisualCheckResponse = Message<"pipeex.pcf.v1.ApplyPcfVisualCheckResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string view_name = 3;
   */
  viewName: string;

  /**
   * @generated from field: int32 group_count = 4;
   */
  groupCount: number;

  /**
   * @generated from field: int32 filter_count = 5;
   */
  filterCount: number;

  /**
   * @generated from field: int32 colored_element_count = 6;
   */
  coloredElementCount: number;

  /**
   * @generated from field: int32 ungrouped_count = 7;
   */
  ungroupedCount: number;
};

/**
 * Describes the message pipeex.pcf.v1.ApplyPcfVisualCheckResponse.
 * Use `create(ApplyPcfVisualCheckResponseSchema)` to create a new message.
 */
export const ApplyPcfVisualCheckResponseSchema: GenMessage<ApplyPcfVisualCheckResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 15);

/**
 * @generated from message pipeex.pcf.v1.ClearPcfVisualCheckRequest
 */
export type ClearPcfVisualCheckRequest = Message<"pipeex.pcf.v1.ClearPcfVisualCheckRequest"> & {
};

/**
 * Describes the message pipeex.pcf.v1.ClearPcfVisualCheckRequest.
 * Use `create(ClearPcfVisualCheckRequestSchema)` to create a new message.
 */
export const ClearPcfVisualCheckRequestSchema: GenMessage<ClearPcfVisualCheckRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 16);

/**
 * @generated from message pipeex.pcf.v1.ClearPcfVisualCheckResponse
 */
export type ClearPcfVisualCheckResponse = Message<"pipeex.pcf.v1.ClearPcfVisualCheckResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string view_name = 3;
   */
  viewName: string;

  /**
   * @generated from field: int32 removed_filter_count = 4;
   */
  removedFilterCount: number;
};

/**
 * Describes the message pipeex.pcf.v1.ClearPcfVisualCheckResponse.
 * Use `create(ClearPcfVisualCheckResponseSchema)` to create a new message.
 */
export const ClearPcfVisualCheckResponseSchema: GenMessage<ClearPcfVisualCheckResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 17);

/**
 * @generated from message pipeex.pcf.v1.LocalPcfCalculationRequest
 */
export type LocalPcfCalculationRequest = Message<"pipeex.pcf.v1.LocalPcfCalculationRequest"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string trace_id = 2;
   */
  traceId: string;

  /**
   * @generated from field: pipeex.pcf.v1.LocalPcfGrouping grouping = 3;
   */
  grouping: LocalPcfGrouping;

  /**
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto settings = 4;
   */
  settings?: PcfSettingsDto | undefined;

  /**
   * Display-name filter only. No Revit ids or parameter values cross the wire.
   *
   * @generated from field: repeated string system_names = 5;
   */
  systemNames: string[];

  /**
   * Same export scope switch as CollectSystemsRequest.include_linked_models:
   * true pulls Revit links into the capture, absent/false — the wire
   * default — keeps the active document as the only source. The React
   * export workspace sends the same value on both calls of one run.
   *
   * @generated from field: bool include_linked_models = 6;
   */
  includeLinkedModels: boolean;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPcfCalculationRequest.
 * Use `create(LocalPcfCalculationRequestSchema)` to create a new message.
 */
export const LocalPcfCalculationRequestSchema: GenMessage<LocalPcfCalculationRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 18);

/**
 * @generated from message pipeex.pcf.v1.LocalPickedPcfCalculationRequest
 */
export type LocalPickedPcfCalculationRequest = Message<"pipeex.pcf.v1.LocalPickedPcfCalculationRequest"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string trace_id = 2;
   */
  traceId: string;

  /**
   * @generated from field: pipeex.pcf.v1.LocalPcfGrouping grouping = 3;
   */
  grouping: LocalPcfGrouping;

  /**
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto settings = 4;
   */
  settings?: PcfSettingsDto | undefined;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPickedPcfCalculationRequest.
 * Use `create(LocalPickedPcfCalculationRequestSchema)` to create a new message.
 */
export const LocalPickedPcfCalculationRequestSchema: GenMessage<LocalPickedPcfCalculationRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 19);

/**
 * @generated from message pipeex.pcf.v1.LocalPcfCalculationProgress
 */
export type LocalPcfCalculationProgress = Message<"pipeex.pcf.v1.LocalPcfCalculationProgress"> & {
  /**
   * @generated from field: pipeex.pcf.v1.LocalPcfCalculationPhase phase = 1;
   */
  phase: LocalPcfCalculationPhase;

  /**
   * @generated from field: int32 processed_groups = 2;
   */
  processedGroups: number;

  /**
   * @generated from field: int32 total_groups = 3;
   */
  totalGroups: number;

  /**
   * @generated from field: int32 percent = 4;
   */
  percent: number;

  /**
   * @generated from field: int32 successful_groups = 5;
   */
  successfulGroups: number;

  /**
   * @generated from field: int32 failed_groups = 6;
   */
  failedGroups: number;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPcfCalculationProgress.
 * Use `create(LocalPcfCalculationProgressSchema)` to create a new message.
 */
export const LocalPcfCalculationProgressSchema: GenMessage<LocalPcfCalculationProgress> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 20);

/**
 * @generated from message pipeex.pcf.v1.LocalPcfCalculationFile
 */
export type LocalPcfCalculationFile = Message<"pipeex.pcf.v1.LocalPcfCalculationFile"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;

  /**
   * @generated from field: string sha256 = 3;
   */
  sha256: string;

  /**
   * Distinct Revit elements represented by this successfully calculated PCF group.
   *
   * @generated from field: int32 element_count = 4;
   */
  elementCount: number;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPcfCalculationFile.
 * Use `create(LocalPcfCalculationFileSchema)` to create a new message.
 */
export const LocalPcfCalculationFileSchema: GenMessage<LocalPcfCalculationFile> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 21);

/**
 * @generated from message pipeex.pcf.v1.LocalPcfCalculationGroupFailure
 */
export type LocalPcfCalculationGroupFailure = Message<"pipeex.pcf.v1.LocalPcfCalculationGroupFailure"> & {
  /**
   * @generated from field: string system_name = 1;
   */
  systemName: string;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string stage = 3;
   */
  stage: string;

  /**
   * @generated from field: string exception_type = 4;
   */
  exceptionType: string;

  /**
   * @generated from field: int32 element_count = 5;
   */
  elementCount: number;

  /**
   * @generated from field: repeated string element_ids = 6;
   */
  elementIds: string[];

  /**
   * @generated from field: int32 additional_element_count = 7;
   */
  additionalElementCount: number;

  /**
   * @generated from field: string suggested_action = 8;
   */
  suggestedAction: string;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPcfCalculationGroupFailure.
 * Use `create(LocalPcfCalculationGroupFailureSchema)` to create a new message.
 */
export const LocalPcfCalculationGroupFailureSchema: GenMessage<LocalPcfCalculationGroupFailure> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 22);

/**
 * @generated from message pipeex.pcf.v1.LocalPcfMappingCoverage
 */
export type LocalPcfMappingCoverage = Message<"pipeex.pcf.v1.LocalPcfMappingCoverage"> & {
  /**
   * @generated from field: int32 project_resolved = 1;
   */
  projectResolved: number;

  /**
   * @generated from field: int32 project_configured = 2;
   */
  projectConfigured: number;

  /**
   * @generated from field: int32 system_resolved = 3;
   */
  systemResolved: number;

  /**
   * @generated from field: int32 system_configured_slots = 4;
   */
  systemConfiguredSlots: number;

  /**
   * @generated from field: int32 system_sources = 5;
   */
  systemSources: number;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPcfMappingCoverage.
 * Use `create(LocalPcfMappingCoverageSchema)` to create a new message.
 */
export const LocalPcfMappingCoverageSchema: GenMessage<LocalPcfMappingCoverage> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 23);

/**
 * @generated from message pipeex.pcf.v1.LocalPcfCalculationResult
 */
export type LocalPcfCalculationResult = Message<"pipeex.pcf.v1.LocalPcfCalculationResult"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string error_stage = 3;
   */
  errorStage: string;

  /**
   * @generated from field: string run_id = 4;
   */
  runId: string;

  /**
   * @generated from field: string trace_id = 5;
   */
  traceId: string;

  /**
   * @generated from field: string pipeline_version = 6;
   */
  pipelineVersion: string;

  /**
   * @generated from field: int32 duration_ms = 7;
   */
  durationMs: number;

  /**
   * @generated from field: int32 element_count = 8;
   */
  elementCount: number;

  /**
   * @generated from field: bool snapshot_cache_hit = 9;
   */
  snapshotCacheHit: boolean;

  /**
   * @generated from field: repeated pipeex.pcf.v1.LocalPcfCalculationFile files = 10;
   */
  files: LocalPcfCalculationFile[];

  /**
   * @generated from field: repeated pipeex.pcf.v1.LocalPcfCalculationGroupFailure group_failures = 11;
   */
  groupFailures: LocalPcfCalculationGroupFailure[];

  /**
   * @generated from field: pipeex.pcf.v1.LocalPcfMappingCoverage mapping_coverage = 12;
   */
  mappingCoverage?: LocalPcfMappingCoverage | undefined;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPcfCalculationResult.
 * Use `create(LocalPcfCalculationResultSchema)` to create a new message.
 */
export const LocalPcfCalculationResultSchema: GenMessage<LocalPcfCalculationResult> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 24);

/**
 * @generated from message pipeex.pcf.v1.LocalPcfCalculationEvent
 */
export type LocalPcfCalculationEvent = Message<"pipeex.pcf.v1.LocalPcfCalculationEvent"> & {
  /**
   * @generated from oneof pipeex.pcf.v1.LocalPcfCalculationEvent.payload
   */
  payload: {
    /**
     * @generated from field: pipeex.pcf.v1.LocalPcfCalculationProgress progress = 1;
     */
    value: LocalPcfCalculationProgress;
    case: "progress";
  } | {
    /**
     * @generated from field: pipeex.pcf.v1.LocalPcfCalculationResult result = 2;
     */
    value: LocalPcfCalculationResult;
    case: "result";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pipeex.pcf.v1.LocalPcfCalculationEvent.
 * Use `create(LocalPcfCalculationEventSchema)` to create a new message.
 */
export const LocalPcfCalculationEventSchema: GenMessage<LocalPcfCalculationEvent> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 25);

/**
 * @generated from message pipeex.pcf.v1.LocalPickedPcfCalculationResult
 */
export type LocalPickedPcfCalculationResult = Message<"pipeex.pcf.v1.LocalPickedPcfCalculationResult"> & {
  /**
   * @generated from field: pipeex.pcf.v1.LocalPcfCalculationResult calculation = 1;
   */
  calculation?: LocalPcfCalculationResult | undefined;

  /**
   * @generated from field: int32 elements_picked = 2;
   */
  elementsPicked: number;

  /**
   * @generated from field: bool cancelled = 3;
   */
  cancelled: boolean;
};

/**
 * Describes the message pipeex.pcf.v1.LocalPickedPcfCalculationResult.
 * Use `create(LocalPickedPcfCalculationResultSchema)` to create a new message.
 */
export const LocalPickedPcfCalculationResultSchema: GenMessage<LocalPickedPcfCalculationResult> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 26);

/**
 * @generated from message pipeex.pcf.v1.LocalPickedPcfCalculationEvent
 */
export type LocalPickedPcfCalculationEvent = Message<"pipeex.pcf.v1.LocalPickedPcfCalculationEvent"> & {
  /**
   * @generated from oneof pipeex.pcf.v1.LocalPickedPcfCalculationEvent.payload
   */
  payload: {
    /**
     * @generated from field: pipeex.pcf.v1.LocalPcfCalculationProgress progress = 1;
     */
    value: LocalPcfCalculationProgress;
    case: "progress";
  } | {
    /**
     * @generated from field: pipeex.pcf.v1.LocalPickedPcfCalculationResult result = 2;
     */
    value: LocalPickedPcfCalculationResult;
    case: "result";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pipeex.pcf.v1.LocalPickedPcfCalculationEvent.
 * Use `create(LocalPickedPcfCalculationEventSchema)` to create a new message.
 */
export const LocalPickedPcfCalculationEventSchema: GenMessage<LocalPickedPcfCalculationEvent> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 27);

/**
 * @generated from message pipeex.pcf.v1.QuickStartMapEntry
 */
export type QuickStartMapEntry = Message<"pipeex.pcf.v1.QuickStartMapEntry"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message pipeex.pcf.v1.QuickStartMapEntry.
 * Use `create(QuickStartMapEntrySchema)` to create a new message.
 */
export const QuickStartMapEntrySchema: GenMessage<QuickStartMapEntry> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 28);

/**
 * @generated from message pipeex.pcf.v1.QuickStartRequest
 */
export type QuickStartRequest = Message<"pipeex.pcf.v1.QuickStartRequest"> & {
  /**
   * @generated from field: pipeex.pcf.v1.PcfSettingsDto settings = 1;
   */
  settings?: PcfSettingsDto | undefined;

  /**
   * @generated from field: repeated pipeex.pcf.v1.QuickStartMapEntry quick_start_map = 2;
   */
  quickStartMap: QuickStartMapEntry[];
};

/**
 * Describes the message pipeex.pcf.v1.QuickStartRequest.
 * Use `create(QuickStartRequestSchema)` to create a new message.
 */
export const QuickStartRequestSchema: GenMessage<QuickStartRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 29);

/**
 * @generated from message pipeex.pcf.v1.QuickStartResponse
 */
export type QuickStartResponse = Message<"pipeex.pcf.v1.QuickStartResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.pcf.v1.ElementTypeProps element_props = 3;
   */
  elementProps: ElementTypeProps[];
};

/**
 * Describes the message pipeex.pcf.v1.QuickStartResponse.
 * Use `create(QuickStartResponseSchema)` to create a new message.
 */
export const QuickStartResponseSchema: GenMessage<QuickStartResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 30);

/**
 * @generated from message pipeex.pcf.v1.ElementTypeProps
 */
export type ElementTypeProps = Message<"pipeex.pcf.v1.ElementTypeProps"> & {
  /**
   * @generated from field: string type_name = 1;
   */
  typeName: string;

  /**
   * @generated from field: repeated int64 elements = 3;
   */
  elements: bigint[];

  /**
   * @generated from field: string skey = 4;
   */
  skey: string;

  /**
   * @generated from field: string object_type = 5;
   */
  objectType: string;

  /**
   * @generated from field: string end1 = 6;
   */
  end1: string;

  /**
   * @generated from field: string end2 = 7;
   */
  end2: string;

  /**
   * @generated from field: string end3 = 8;
   */
  end3: string;

  /**
   * @generated from field: string end4 = 9;
   */
  end4: string;
};

/**
 * Describes the message pipeex.pcf.v1.ElementTypeProps.
 * Use `create(ElementTypePropsSchema)` to create a new message.
 */
export const ElementTypePropsSchema: GenMessage<ElementTypeProps> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 31);

/**
 * @generated from message pipeex.pcf.v1.PcfConfigRequest
 */
export type PcfConfigRequest = Message<"pipeex.pcf.v1.PcfConfigRequest"> & {
};

/**
 * Describes the message pipeex.pcf.v1.PcfConfigRequest.
 * Use `create(PcfConfigRequestSchema)` to create a new message.
 */
export const PcfConfigRequestSchema: GenMessage<PcfConfigRequest> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 32);

/**
 * @generated from message pipeex.pcf.v1.PcfConfigResponse
 */
export type PcfConfigResponse = Message<"pipeex.pcf.v1.PcfConfigResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.pcf.v1.PropData element_props = 3;
   */
  elementProps: PropData[];
};

/**
 * Describes the message pipeex.pcf.v1.PcfConfigResponse.
 * Use `create(PcfConfigResponseSchema)` to create a new message.
 */
export const PcfConfigResponseSchema: GenMessage<PcfConfigResponse> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 33);

/**
 * @generated from message pipeex.pcf.v1.PropData
 */
export type PropData = Message<"pipeex.pcf.v1.PropData"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: pipeex.pcf.v1.PropStorageType property_type = 2;
   */
  propertyType: PropStorageType;

  /**
   * @generated from field: pipeex.pcf.v1.PropType prop_type = 3;
   */
  propType: PropType;

  /**
   * @generated from field: bool is_shared = 4;
   */
  isShared: boolean;

  /**
   * @generated from field: string unit_type = 5;
   */
  unitType: string;
};

/**
 * Describes the message pipeex.pcf.v1.PropData.
 * Use `create(PropDataSchema)` to create a new message.
 */
export const PropDataSchema: GenMessage<PropData> = /*@__PURE__*/
  messageDesc(file_pcf_export_service, 34);

/**
 * @generated from enum pipeex.pcf.v1.SettingsType
 */
export enum SettingsType {
  /**
   * @generated from enum value: SETTINGS_TYPE_COMPANY = 0;
   */
  COMPANY = 0,

  /**
   * @generated from enum value: SETTINGS_TYPE_USER = 1;
   */
  USER = 1,
}

/**
 * Describes the enum pipeex.pcf.v1.SettingsType.
 */
export const SettingsTypeSchema: GenEnum<SettingsType> = /*@__PURE__*/
  enumDesc(file_pcf_export_service, 0);

/**
 * @generated from enum pipeex.pcf.v1.LocalPcfGrouping
 */
export enum LocalPcfGrouping {
  /**
   * @generated from enum value: LOCAL_PCF_GROUPING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCAL_PCF_GROUPING_BY_SYSTEM_NAME = 1;
   */
  BY_SYSTEM_NAME = 1,

  /**
   * @generated from enum value: LOCAL_PCF_GROUPING_BY_SYSTEM_TYPE_NAME = 2;
   */
  BY_SYSTEM_TYPE_NAME = 2,

  /**
   * @generated from enum value: LOCAL_PCF_GROUPING_BY_PARAMETER = 3;
   */
  BY_PARAMETER = 3,
}

/**
 * Describes the enum pipeex.pcf.v1.LocalPcfGrouping.
 */
export const LocalPcfGroupingSchema: GenEnum<LocalPcfGrouping> = /*@__PURE__*/
  enumDesc(file_pcf_export_service, 1);

/**
 * @generated from enum pipeex.pcf.v1.PcfVisualParameterSource
 */
export enum PcfVisualParameterSource {
  /**
   * @generated from enum value: PCF_VISUAL_PARAMETER_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PCF_VISUAL_PARAMETER_SOURCE_ELEMENT = 1;
   */
  ELEMENT = 1,

  /**
   * @generated from enum value: PCF_VISUAL_PARAMETER_SOURCE_TYPE = 2;
   */
  TYPE = 2,
}

/**
 * Describes the enum pipeex.pcf.v1.PcfVisualParameterSource.
 */
export const PcfVisualParameterSourceSchema: GenEnum<PcfVisualParameterSource> = /*@__PURE__*/
  enumDesc(file_pcf_export_service, 2);

/**
 * @generated from enum pipeex.pcf.v1.LocalPcfCalculationPhase
 */
export enum LocalPcfCalculationPhase {
  /**
   * @generated from enum value: LOCAL_PCF_CALCULATION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCAL_PCF_CALCULATION_PHASE_CAPTURE = 1;
   */
  CAPTURE = 1,

  /**
   * @generated from enum value: LOCAL_PCF_CALCULATION_PHASE_CALCULATE = 2;
   */
  CALCULATE = 2,
}

/**
 * Describes the enum pipeex.pcf.v1.LocalPcfCalculationPhase.
 */
export const LocalPcfCalculationPhaseSchema: GenEnum<LocalPcfCalculationPhase> = /*@__PURE__*/
  enumDesc(file_pcf_export_service, 3);

/**
 * @generated from enum pipeex.pcf.v1.PropStorageType
 */
export enum PropStorageType {
  /**
   * @generated from enum value: PROP_STORAGE_TYPE_STRING = 0;
   */
  STRING = 0,

  /**
   * @generated from enum value: PROP_STORAGE_TYPE_INTEGER = 1;
   */
  INTEGER = 1,

  /**
   * @generated from enum value: PROP_STORAGE_TYPE_ELEMENT_ID = 2;
   */
  ELEMENT_ID = 2,

  /**
   * @generated from enum value: PROP_STORAGE_TYPE_DOUBLE = 3;
   */
  DOUBLE = 3,

  /**
   * @generated from enum value: PROP_STORAGE_TYPE_BOOLEAN = 4;
   */
  BOOLEAN = 4,
}

/**
 * Describes the enum pipeex.pcf.v1.PropStorageType.
 */
export const PropStorageTypeSchema: GenEnum<PropStorageType> = /*@__PURE__*/
  enumDesc(file_pcf_export_service, 4);

/**
 * @generated from enum pipeex.pcf.v1.PropType
 */
export enum PropType {
  /**
   * @generated from enum value: PROP_TYPE_INSTANCE = 0;
   */
  INSTANCE = 0,

  /**
   * @generated from enum value: PROP_TYPE_TYPE = 1;
   */
  TYPE = 1,
}

/**
 * Describes the enum pipeex.pcf.v1.PropType.
 */
export const PropTypeSchema: GenEnum<PropType> = /*@__PURE__*/
  enumDesc(file_pcf_export_service, 5);

/**
 * Domain operations for PCF export and configuration.
 * Handles piping system collection, export, validation, and configuration retrieval.
 *
 * @generated from service pipeex.pcf.v1.PcfExportService
 */
export const PcfExportService: GenService<{
  /**
   * Collect available piping systems from the active Revit document
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.CollectSystems
   */
  collectSystems: {
    methodKind: "unary";
    input: typeof CollectSystemsRequestSchema;
    output: typeof CollectSystemsResponseSchema;
  },
  /**
   * Start system collection as a host operation with live progress.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.StartCollectSystems
   */
  startCollectSystems: {
    methodKind: "unary";
    input: typeof CollectSystemsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * DEPRECATED — kept for proto wire backward-compatibility only. The
   * server-side handler returns IsSuccess=false with a deprecation
   * message. Use CollectSnapshotForExport + POST /api/pcf-runs +
   * WritePcfFilesToDisk instead. F1 of epic
   * 2026-05-26_export-flow-and-observability.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.ExportSystems
   */
  exportSystems: {
    methodKind: "unary";
    input: typeof ExportSystemsRequestSchema;
    output: typeof ExportSystemsResponseSchema;
  },
  /**
   * DEPRECATED — see ExportSystems above.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.StartExportSystems
   */
  startExportSystems: {
    methodKind: "unary";
    input: typeof ExportSystemsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Build the active document snapshot without writing files. The browser
   * forwards the gzip payload to authenticated POST /api/pcf-runs.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.CollectSnapshotForExport
   */
  collectSnapshotForExport: {
    methodKind: "unary";
    input: typeof CollectSnapshotForExportRequestSchema;
    output: typeof CollectSnapshotForExportResponseSchema;
  },
  /**
   * Hide the plugin window, let the user pick exact Revit elements, and return
   * a gzip snapshot for the same authenticated browser -> API export pipeline.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.CollectPickedSnapshotForExport
   */
  collectPickedSnapshotForExport: {
    methodKind: "unary";
    input: typeof CollectPickedSnapshotForExportRequestSchema;
    output: typeof CollectPickedSnapshotForExportResponseSchema;
  },
  /**
   * Capture the active document on Revit's thread, then calculate PCF on a
   * plugin worker. Events contain aggregate progress and one terminal result.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.CalculateLocalPcf
   */
  calculateLocalPcf: {
    methodKind: "server_streaming";
    input: typeof LocalPcfCalculationRequestSchema;
    output: typeof LocalPcfCalculationEventSchema;
  },
  /**
   * Pick exact elements on Revit's thread, then calculate the picked snapshot
   * on a plugin worker. User cancellation is a terminal non-error disposition.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.CalculatePickedLocalPcf
   */
  calculatePickedLocalPcf: {
    methodKind: "server_streaming";
    input: typeof LocalPickedPcfCalculationRequestSchema;
    output: typeof LocalPickedPcfCalculationEventSchema;
  },
  /**
   * Apply or replace PipeeX-owned grouping filters in Revit's active 3D view.
   * Only aggregate counts cross the wire; group identities stay in the plugin.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.ApplyPcfVisualCheck
   */
  applyPcfVisualCheck: {
    methodKind: "unary";
    input: typeof ApplyPcfVisualCheckRequestSchema;
    output: typeof ApplyPcfVisualCheckResponseSchema;
  },
  /**
   * Remove only PipeeX visual-check filters owned by the active 3D view.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.ClearPcfVisualCheck
   */
  clearPcfVisualCheck: {
    methodKind: "unary";
    input: typeof ClearPcfVisualCheckRequestSchema;
    output: typeof ClearPcfVisualCheckResponseSchema;
  },
  /**
   * F1 of epic 2026-05-26_export-flow-and-observability: persist a
   * batch of PCF files (returned by /api/pcf-runs) onto the user's
   * chosen folder. Collisions are reported in `skipped_files` —
   * existing files are NEVER overwritten.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.WritePcfFilesToDisk
   */
  writePcfFilesToDisk: {
    methodKind: "unary";
    input: typeof WritePcfFilesToDiskRequestSchema;
    output: typeof WritePcfFilesToDiskResponseSchema;
  },
  /**
   * Retrieve quick start data for the current document
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.GetQuickStartData
   */
  getQuickStartData: {
    methodKind: "unary";
    input: typeof QuickStartRequestSchema;
    output: typeof QuickStartResponseSchema;
  },
  /**
   * Start quick-start data collection as a host operation with live progress.
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.StartGetQuickStartData
   */
  startGetQuickStartData: {
    methodKind: "unary";
    input: typeof QuickStartRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Retrieve PCF configuration properties from the current document
   *
   * @generated from rpc pipeex.pcf.v1.PcfExportService.GetPcfConfiguration
   */
  getPcfConfiguration: {
    methodKind: "unary";
    input: typeof PcfConfigRequestSchema;
    output: typeof PcfConfigResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pcf_export_service, 0);

